import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class TimerService {
  private interval: any;

  start(endTime: number, cb: (remaining: number) => void) {
    this.stop();

    this.interval = setInterval(() => {
      const now = Date.now();
      const remaining = Math.max(0, Math.floor((endTime - now) / 1000));

      cb(remaining);

      if (remaining <= 0) {
        this.stop();
      }
    }, 1000);
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
